<template>
    <div 
        class="h-100"
        v-tinymce="options"
        :key="renderKey"
        @mce-change="(content) => offerSectionSet({trainerProfile: content})"
        @mce-dirty="() => $emit('dirty')"
    >
        <div v-if="offerSections.trainerProfile" v-html="offerSections.trainerProfile" class="h-100"></div>
        <b-card v-else class="trainer-profile">
            <b-row>
                <b-col v-if="hasImage" md="2" class="trainer-image">
                    <img :src="imageUrl" :alt="trainerName">
                </b-col>
                <b-col :md="hasImage ? '10' : '12'">
                    <h4>{{ $t(isFemale ? 'trainerProfile.femaleHeading' : 'trainerProfile.maleHeading') }}</h4>
                    <h3>{{ trainerTitle }} {{ trainerName }}</h3>
                    <p>{{ $t('trainerProfile.topics') }}</p>
                    <ul>
                        <li v-for="topic in topics" :key="topic.id">{{topic.title}}</li>
                    </ul>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>
import Config from '../../misc/Config';
import placeholder from './placeholder'
import { mapGetters, mapMutations } from 'vuex';

export default {
    name: 'TrainerProfile',
    props: {
        options: Object
    },
    mixins: [placeholder],
    data: function() {
        return  {
            renderKey: 0
        }
    },
    computed: {
        ...mapGetters([
            'trainer',
            'trainerTopics',
            'offerSections',
        ]),
        hasImage: function () {
            return this.trainer && this.trainer.imageUrl;
        },
        imageUrl: function () {
            return this.trainer && this.trainer.imageUrl
                ? Config.GFU_API_URL.replace(/api$/, '') + this.trainer.imageUrl
                : this.placeholderImg;
        },
        trainerName: function () {
            return this.trainer && this.trainer.contact
                ? this.trainer.contact.firstName + ' ' + this.trainer.contact.lastName
                : this.placeholder;
        },
        trainerTitle: function () {
            let title =  this.trainer && this.trainer.contact
                ? this.trainer.contact.gender === 'm'
                ? this.$t('trainerProfile.maleTitle')
                : ['f', 'w'].includes(this.trainer.contact.gender)
                  ? this.$t('trainerProfile.femaleTitle')
                  : ''
                : this.placeholder;
            if(this.trainer && this.trainer.contact && this.trainer.contact.title) {
                title += ' ' + this.trainer.contact.title;
            }
            return title;
        },
        isFemale: function () {
            return this.trainer && this.trainer.contact && (this.trainer.contact.gender === 'f' || this.trainer.contact.gender === 'w');
        },
        topics: function () {
            return this.trainerTopics
                ? this.trainerTopics
                : [];

        }
    },
    methods: {
        ...mapMutations([
            'offerSectionSet',
        ]),
    },
    watch: {
        trainer: function(){
            this.renderKey++;
        },
        trainerTopics: function () {
            this.renderKey++;
        }
    }
}
</script>

<style scoped>
.trainer-profile-wrapper {
    height: 100%;
}
</style>
